import { Checkbox, Grid, Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';

type DropdownWithCheckboxesProps = {
  entities: any[];
  onClose: () => void;
  onSave: () => void;
  anchorEl: HTMLElement | null;
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  displayFieldKey: string;
  subtextFieldKey?: string;
  label?: string;
  isDisabled?: (entity: any) => boolean;
};

export function DropdownWithCheckboxes(props: DropdownWithCheckboxesProps) {
  const handleSelect = (id: string) => {
    if (props.selectedIds.includes(id)) {
      props.setSelectedIds(props.selectedIds.filter(i => i !== id));
    } else {
      props.setSelectedIds([...props.selectedIds, id]);
    }
  };

  return (
    <Menu
      anchorEl={props.anchorEl}
      id='account-menu'
      open={Boolean(props.anchorEl)}
      onClose={props.onClose}
      elevation={0}
      sx={styles.menu}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {props.label && <MenuItem>{props.label}</MenuItem>}
      {props.entities.map(entity => {
        return (
          <MenuItem
            key={entity!.id}
            onClick={() => handleSelect(entity.id)}
            disabled={props.isDisabled ? props.isDisabled(entity) : false}
          >
            <Checkbox checked={props.selectedIds.includes(entity.id)} />{' '}
            <Grid container item direction={'column'}>
              <Grid item>
                <Typography>{entity[props.displayFieldKey]}</Typography>
              </Grid>
              {props.subtextFieldKey && (
                <Grid item>
                  <Typography variant={'caption'}>{entity[props.subtextFieldKey]}</Typography>
                </Grid>
              )}
            </Grid>
          </MenuItem>
        );
      })}
      <MenuItem
        onClick={() => {
          props.onSave();
          props.onClose();
        }}
      >
        <Typography>Save</Typography>
      </MenuItem>
    </Menu>
  );
}

const styles = {
  menu: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
};
